import * as React from 'react';

type FormTextAreaProps = React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

interface ITextAreaProps extends FormTextAreaProps {
	displaytextcounter?: 'true' | 'false';
	widthtype?: 'narrow' | 'half' | 'normal' | 'wide' | 'full';
}

interface ITextAreaState {
	displaytextcounter?: boolean;
}

export class FormInputTextArea extends React.Component<ITextAreaProps, ITextAreaState> {

	constructor(props: ITextAreaProps) {
		super(props);
		this.state = {
			displaytextcounter: this.props.displaytextcounter === 'true' ? true : false
		} as ITextAreaState;
	}

	public componentWillMount() {
		const state = this.state || {} as ITextAreaState;

		if (state.displaytextcounter === undefined) {
			this.setState({ displaytextcounter: false });
		}
	}

	public render() {
		const state = this.state || {} as ITextAreaState;
		const attrs = this.props || {} as ITextAreaProps;

		const containerClassList = ['form__input--container'];
		const widthType = attrs.widthtype ? attrs.widthtype : 'wide';
		containerClassList.push(`form__input--container--${widthType}`);

		const classList = ['form__input', 'form__input--textarea'];

		if (attrs['is-valid'] === 'false' || false) {
			classList.push('form__input--error');
		}

		if (attrs.readOnly) {
			classList.push('form__input--readonly');
		}

		return <React.Fragment><div className={containerClassList.join(' ')}>
			<textarea className={classList.join(' ')} {...attrs}>{attrs.children}</textarea>
			<div>{
				state.displaytextcounter ? <div className="form_input--text--counter">
					<p>(minimum <span className="form_input--text--counter--min_length">{this.props.minLength}</span>) <span
						className="form_input--text--counter--current_length">{(this.props.value as string || []).length}</span></p></div>
					: null
			}
			</div>
		</div>
		</React.Fragment>;
	}
}
